export default __webpack_public_path__ + "static/miniboo-3ee3b3c0d67b7ab8a511fb5e98fea369.png";